import { render } from "./MakeBriefing.vue?vue&type=template&id=abbcae9e"
import script from "./MakeBriefing.vue?vue&type=script&lang=js"
export * from "./MakeBriefing.vue?vue&type=script&lang=js"

import "./MakeBriefing.vue?vue&type=style&index=0&id=abbcae9e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__